import type {Store} from 'redux'
import type {AppState} from './store/types/app-state'
import configureGlobalStore from './store/configure-store'

export const store: Store<AppState> = configureGlobalStore()
